import { useEffect, useRef, useState } from "react";

import "./HomePartyScene.css";

const LOOP_SECONDS = 18;
const STILL_SECONDS = 6.8;

export function HomePartyScene({ compact = false }: { compact?: boolean }) {
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const [visible, setVisible] = useState(!document.hidden);
  const [inView, setInView] = useState(true);
  const elapsedRef = useRef(reducedMotion ? STILL_SECONDS : 0);
  const frameRef = useRef<HTMLIFrameElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  function sendTime(time: number) {
    frameRef.current?.contentWindow?.postMessage({ type: "home-party-seek", time }, window.location.origin);
  }

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onMotionChange = () => {
      setReducedMotion(media.matches);
    };
    const onVisibility = () => setVisible(!document.hidden);
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting));
    if (wrapperRef.current) observer.observe(wrapperRef.current);
    media.addEventListener("change", onMotionChange);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      observer.disconnect();
      media.removeEventListener("change", onMotionChange);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  useEffect(() => {
    if (reducedMotion || !visible || !inView) return;
    let frame = 0;
    let previousTime: number | null = null;
    const tick = (now: number) => {
      if (previousTime !== null) elapsedRef.current = (elapsedRef.current + Math.min((now - previousTime) / 1000, 0.1)) % LOOP_SECONDS;
      previousTime = now;
      sendTime(elapsedRef.current);
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [reducedMotion, visible, inView]);

  return <div className={`home-party-scene${compact ? " home-party-scene-compact" : ""}`} ref={wrapperRef}>
    <div className="home-party-scene-art" aria-hidden="true">
      <iframe ref={frameRef} src="/home-party-scene/index.html" title="Friends drawing a clue, tossing a die, and waving" tabIndex={-1} onLoad={() => sendTime(elapsedRef.current)} />
    </div>
  </div>;
}
